import React from "react";
import EventTemplateCategory from "../../../stores/domainStore/pages/models/eventTemplateCategory";
import EventTemplateCategoryItem from "../eventTemplateCategoryItem/eventTemplateCategoryItem";
import {useStores} from "../../../stores/useStores";
import {runInAction} from "mobx";
import {observer} from "mobx-react-lite";
import EventTemplateSummaryItem from "../../../stores/domainStore/pages/models/eventTemplateSummaryItem";
import {EventTemplateStatus} from "../../../shared/enums/eventTemplateStatus";
import "./eventTemplateCategoriesList.sass";

export interface IEventTemplateCategoriesProps {
  eventTemplateCategories: EventTemplateCategory[];
  templateViewStatus: EventTemplateStatus;
  onEditTemplate: (eventTemplate: EventTemplateSummaryItem) => void;
  onSelectTemplate: (eventTemplate: EventTemplateSummaryItem) => void;
  onUpdateTemplateStatusClick: (
    eventTemplate: EventTemplateSummaryItem,
    status: EventTemplateStatus
  ) => void;
}

const EventTemplateCategoriesList: React.FC<IEventTemplateCategoriesProps> = ({
  eventTemplateCategories,
  templateViewStatus,
  onEditTemplate,
  onSelectTemplate,
  onUpdateTemplateStatusClick
}) => {
  const {
    uiStore: {eventCatalogueUiStore}
  } = useStores();

  const setIsExpanded = (id: string, isExpanded: boolean) => {
    runInAction(() => {
      eventCatalogueUiStore.expandedCategoryId = isExpanded ? id : "";
    });
  };

  const items = eventTemplateCategories.map((eventTemplateCategory) => (
    <EventTemplateCategoryItem
      key={eventTemplateCategory.id}
      eventTemplateCategory={eventTemplateCategory}
      templateViewStatus={templateViewStatus}
      expandedCategoryId={eventCatalogueUiStore.expandedCategoryId}
      setIsExpanded={setIsExpanded}
      sortEventTemplates={eventCatalogueUiStore.sortEventTemplates}
      onEditTemplate={onEditTemplate}
      onSelectTemplate={onSelectTemplate}
      onUpdateTemplateStatusClick={onUpdateTemplateStatusClick}
    />
  ));
  return (
    <div
      className="event-categories-accordion accordion"
      data-testid="eventTemplateCategoriesList"
    >
      {items}
    </div>
  );
};

export default observer(EventTemplateCategoriesList);
